/* src/components/Icons/Rhombus.svelte generated by Svelte v3.54.0 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	init,
	insert,
	noop,
	safe_not_equal,
	svg_element,
	toggle_class
} from "svelte/internal";

function create_fragment(ctx) {
	let svg;
	let path;
	let svg_class_value;

	return {
		c() {
			svg = svg_element("svg");
			path = svg_element("path");
			attr(path, "stroke", "#5D6066");
			attr(path, "stroke-linejoin", "round");
			attr(path, "stroke-width", "1.25");
			attr(path, "d", "M3.515 12 12 3.514 20.485 12 12 20.485z");
			attr(path, "class", "fastboard-icon-stroke-color");
			attr(svg, "fill", "none");
			attr(svg, "viewBox", "0 0 24 24");
			attr(svg, "class", svg_class_value = "fastboard-icon " + /*theme*/ ctx[0]);
			toggle_class(svg, "is-active", /*active*/ ctx[1]);
		},
		m(target, anchor) {
			insert(target, svg, anchor);
			append(svg, path);
		},
		p(ctx, [dirty]) {
			if (dirty & /*theme*/ 1 && svg_class_value !== (svg_class_value = "fastboard-icon " + /*theme*/ ctx[0])) {
				attr(svg, "class", svg_class_value);
			}

			if (dirty & /*theme, active*/ 3) {
				toggle_class(svg, "is-active", /*active*/ ctx[1]);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(svg);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { theme = "light" } = $$props;
	let { active = false } = $$props;

	$$self.$$set = $$props => {
		if ('theme' in $$props) $$invalidate(0, theme = $$props.theme);
		if ('active' in $$props) $$invalidate(1, active = $$props.active);
	};

	return [theme, active];
}

class Rhombus extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { theme: 0, active: 1 });
	}
}

export default Rhombus;